module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "slider"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.activeImage,
      "transition": "fade"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.length > 1),
      expression: "images.length > 1"
    }],
    staticClass: "slider-controls"
  }, [_c('img', {
    staticClass: "prev-slide",
    attrs: {
      "src": "/static/prev.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.step(-1)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "next-slide",
    attrs: {
      "src": "/static/next.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.step(1)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.length > 1),
      expression: "images.length > 1"
    }],
    staticClass: "prev-button btn btn-default",
    on: {
      "click": function($event) {
        _vm.step(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.previousButton))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.length > 1),
      expression: "images.length > 1"
    }],
    staticClass: "next-button btn btn-default",
    on: {
      "click": function($event) {
        _vm.step(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.nextButton))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3174987a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/BasicSlider.vue
// module id = 250
// module chunks = 1